<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}}</text>
      </div>
    </div>
    <div class="pub-center pt-2" >
      <el-card style="width: 100%;max-width: 600px"  shadow="always">
        <div class="d-flex align-items-center justify-content-around">
          <div>
            <div class="fw-bold fw-bold mb-1">待发送</div>
            <div>0</div>
          </div>
          <div>
            <div class="fw-bold fw-bold mb-1">已发送</div>
            <div>0</div>
          </div>
          <div>
            <div class="fw-bold fw-bold mb-1">发送失败</div>
            <div>0</div>
          </div>
        </div>
        <el-button class="mt-5" type="primary" :disabled="loading" style="width: 100px" @click="sendMessageConfirm">{{loading?"正在发送...":"发送"}}</el-button>
        <div class="small text-secondary mt-2">注:点击发送按钮，群发短信对象为所有进入复赛的团队!</div>

      </el-card>
    </div>


  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
const loading = ref(false)

onMounted(()=>{

})
const sendMessageConfirm = ()=>{
  return ElMessage.warning(`功能暂未开放`)
  ElMessageBox.alert('确定要发送信息吗？', '发送短信', {
    confirmButtonText: '确定',
    cancelButtonText:"取消",
    callback: (action) => {
      if(action==='confirm'){ // 确定
        sendMessage()
      }
    },
  })
}

const sendMessage = ()=>{
  loading.value = true
  setTimeout(()=>{
    ElMessage.success(`发送成功`)
    loading.value = false
  },2000)
}

</script>

<style scoped lang="scss">


</style>
